import React from "react"
import SocialSharing from "../SocialSharing"
import "./Footer.scss"

const Footer = () => (
  <div className="footer-wrapper">
    <footer id="footer" className="footer">
      <SocialSharing />
    </footer>
  </div>
)
export default Footer
